import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View, Text } from 'react-native';
import { UPDATE_PADDLE_SERVICE } from './queries';
import { useParams } from 'react-router-dom';
import { PADDLE_SERVICE_CODES } from '.';

const EditPaddleService = ({setShowModal, refetch, paddleService}) => {
  const [submitting, setSubmitting] = useState();
  const [assets, setAssets] = useState();
  const { assetId } = useParams();
  const [updatePaddleService] = useMutation(UPDATE_PADDLE_SERVICE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input.sort = parseInt(input.sort || '99');
    updatePaddleService({ variables: input });
  });

  const { control, handleSubmit, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      id: paddleService.id,
      name: paddleService.name || '',
      code: paddleService.code || '',
      serviceFeePercent: paddleService.serviceFeePercent || '',
      additionalFeePercent: paddleService.additionalFeePercent || 10,
      sort: paddleService.sort || 99,
      presaleScreen: paddleService.presaleScreen,
      applySalesTaxByDefault: paddleService.applySalesTaxByDefault || false,
    }
  });

  const watchServiceFeePercent = watch('serviceFeePercent');
  const watchAdditionalFeePercent = watch('additionalFeePercent');

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
            {...register("name", {
              required: true,
            })}
          />
          <Input.Text
            label="Code:"
            name="code"
            control={control}
            errors={errors}
            {...register("code", {
              required: true,
            })}
          />
          <Input.Number
            label="Sort (lower numbers listed first on sale screens):"
            name="sort"
            control={control}
            errors={errors}
            {...register("sort", { required: true, })}
          />
          <Input.Switch
            label="Include on Pre-sale screen toggles?"
            name="presaleScreen"
            control={control}
            errors={errors}
          />
          <Input.Switch
            label="Apply sales tax by default? (in-house/floor channels)"
            name="applySalesTaxByDefault"
            control={control}
            errors={errors}
          />
          <Input.Number
            label="Paddle Service Fee - Percent of Sale Price:"
            name="serviceFeePercent"
            control={control}
            errors={errors}
            {...register("serviceFeePercent", {
              required: true,
              validate: {
                matchPattern: (v) =>
                  /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                  "Please use number only without commas",
              },
            })}
          />
          <Input.Number
            label="Additional Percent added for Buy Fee:"
            name="additionalFeePercent"
            control={control}
            errors={errors}
            {...register("additionalFeePercent", {
              required: true,
              validate: {
                matchPattern: (v) =>
                  /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                  "Please use number only without commas",
              },
            })}
          />
          <View style={{display: 'flex', flexDirection: 'row'}}>
            <Text>Total Buy Fee Percent:</Text>
            &nbsp;&nbsp;
            { watchServiceFeePercent && watchAdditionalFeePercent &&
              parseFloat(watchServiceFeePercent) + parseFloat(watchAdditionalFeePercent)
            }
            %
          </View>
          <ButtonContainer>
            <ButtonGroup>
              <Button
                label="Update Paddle Service"
                onPress={handleSubmit(onSubmit)}
                style={{width: 'fit-content'}}
              />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditPaddleService;
